<br />
<footer class="footer__area">
  <div class="footer__top">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div class="footer__widget">
            <div class="logo mb-35">
              <a href="index.html">
                <img src="../../assets/img/logo/logo.png" alt="img" />
              </a>
            </div>
            <div class="footer__content">
              <p>4200 Indian Bayou Trail Destin, FL 32541</p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
          <div class="footer__widget">
            <h4 class="footer__widget-title">Links</h4>
            <div class="footer__link">
              <ul class="list-wrap">
                <li><a href="/home">Home</a></li>
                <li *appPortalFeature="'invoice'">
                  <a href="/vendor-invoice" *appPortalButton>
                    Vendor Invoice Submission
                  </a>
                  <a
                    href="/login?from=invoice"
                    *appPortalLoginRequired
                    class="login-required-link"
                  >
                    Vendor Invoice Submission
                  </a>
                </li>
                <li *appPortalFeature="'invoice'">
                  <a href="/multiple-invoices" *appPortalButton>
                    Multiple Invoices Submission
                  </a>
                  <a
                    href="/login?from=invoice"
                    *appPortalLoginRequired
                    class="login-required-link"
                  >
                    Multiple Invoices Submission
                  </a>
                </li>
                <li *appPortalFeature="'registration'">
                  <a href="/vendor-registration">New Vendor Registration</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
          <div class="footer__widget">
            <h4 class="footer__widget-title">Our Features</h4>
            <div class="footer__link">
              <ul class="list-wrap">
                <li *appPortalFeature="'invoice'">
                  <a href="/vendor-invoice" *appPortalButton>
                    Vendor Invoice Submission
                  </a>
                  <a
                    href="/login?from=invoice"
                    *appPortalLoginRequired
                    class="login-required-link"
                  >
                    Vendor Invoice Submission
                  </a>
                </li>
                <li *appPortalFeature="'registration'">
                  <a href="/vendor-registration">New Vendor Registration</a>
                </li>
                <li *appPortalFeature="'signup'">
                  <a href="/vendor-sign-up">Vendor Profile Setup</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div class="footer__widget">
            <h4 class="footer__widget-title">Get In Touch</h4>
            <div class="footer__contact-content">
              <p>
                Accountspayable&#64;cityofdestin.com<br />
                850-837-4242
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
